// src/components/HiddenSubmissionsDataGridColumns.js

// Helper to normalize possibly stringified objects
function parseObject(object) {
    return typeof object === 'string' ? JSON.parse(object) : object || {};
  }
  
  export const submissionColumns = [
    { field: 'id', headerName: 'ID', flex: 0.5, minWidth: 100 },
    {
      field: 'trackingNumber',
      headerName: '#',
      flex: 0,
      minWidth: 60,
      valueGetter: ({ row }) => row.meta?.trackingNumber ?? '',
    },
    {
      field: 'firstName',
      headerName: 'First Name',
      flex: 1,
      minWidth: 90,
      valueGetter: ({ row }) => parseObject(row.meta?.owner).givenName ?? '',
    },
    {
      field: 'lastName',
      headerName: 'Last Name',
      flex: 1,
      minWidth: 100,
      valueGetter: ({ row }) => parseObject(row.meta?.owner).familyName ?? '',
    },
    {
      field: 'email',
      headerName: 'Email',
      flex: 1,
      minWidth: 150,
      valueGetter: ({ row }) => parseObject(row.meta?.owner).email ?? '',
    },
    {
      field: 'formToken',
      headerName: 'Form Token',
      flex: 0,
      minWidth: 100,
      valueGetter: ({ row }) => row.formToken ?? '',
    },
    {
      field: 'title',
      headerName: 'Title',
      flex: 2,
      valueGetter: ({ row }) => row.data?.title ?? '',
    },
  ];
  
  export const reviewColumns = (allSubmissions) => {
    // Helper to find the linkedData item with fileType === "JSON"
    const getJsonLink = (row) => {
      const arr = row.linkedData || [];
      for (let item of arr) {
        const parsed = parseObject(item);
        const modelType = String(parsed.modelType ?? parsed.model ?? '').toUpperCase();
        if (parsed.fileType === 'JSON' && modelType === 'SUBMISSION' && parsed.linkedTo) {
          return parsed;
        }
      }
      return {};
    };
  
    return [
      { field: 'id', headerName: 'ID', flex: 0.5, minWidth: 100 },
      {
        field: 'trackingNumber',
        headerName: '#',
        flex: 0,
        minWidth: 60,
        valueGetter: ({ row }) => row.meta?.trackingNumber ?? '',
      },
      {
        field: 'firstName',
        headerName: 'First Name',
        flex: 1,
        minWidth: 90,
        valueGetter: ({ row }) => parseObject(row.meta?.owner).givenName ?? '',
      },
      {
        field: 'lastName',
        headerName: 'Last Name',
        flex: 1,
        minWidth: 100,
        valueGetter: ({ row }) => parseObject(row.meta?.owner).familyName ?? '',
      },
      {
        field: 'email',
        headerName: 'Email',
        flex: 1,
        minWidth: 150,
        valueGetter: ({ row }) => parseObject(row.meta?.owner).email ?? '',
      },
      {
        field: 'linkedId',
        headerName: 'Linked ID',
        flex: 1,
        minWidth: 100,
        valueGetter: ({ row }) => getJsonLink(row).linkedTo ?? '',
      },
      {
        field: 'submissionTracking',
        headerName: 'Sub #',
        flex: 1,
        minWidth: 60,
        valueGetter: ({ row }) => {
          const link = getJsonLink(row);
          const submissionId = link.linkedTo;
          const submission = allSubmissions.find((s) => s.id === submissionId);
          return submission?.meta?.trackingNumber ?? '';
        },
      },
      {
        field: 'submitterFirstName',
        headerName: 'Sub First Name',
        flex: 1,
        minWidth: 90,
        valueGetter: ({ row }) => {
          const link = getJsonLink(row);
          const submission = allSubmissions.find((s) => s.id === link.id);
          return parseObject(submission?.meta?.owner)?.givenName ?? '';
        },
      },
      {
        field: 'submitterLastName',
        headerName: 'Sub Last Name',
        flex: 1,
        minWidth: 100,
        valueGetter: ({ row }) => {
          const link = getJsonLink(row);
          const submission = allSubmissions.find((s) => s.id === link.id);
          return parseObject(submission?.meta?.owner)?.familyName ?? '';
        },
      },
      {
        field: 'submitterEmail',
        headerName: 'Sub Email',
        flex: 1.5,
        minWidth: 150,
        valueGetter: ({ row }) => {
          const link = getJsonLink(row);
          const submission = allSubmissions.find((s) => s.id === link.id);
          return parseObject(submission?.meta?.owner)?.email ?? '';
        },
      },
    ];
  };
  
